import React, { Component,Suspense,lazy } from 'react';

const Layout = lazy(() => import('./Layout/Layout'));

class App extends Component {

  constructor(){
    super()
    // Listen for orientation changes
      window.addEventListener("orientationchange", function() {
        window.location.reload(true);
      }, false);
  }

  componentDidMount(){
   
  }

  render() {

    return (
      // <div style={{overflow:'hidden'}}>
      //     <Aux>
      //       <Suspense fallback={<div />}> 
      //         <Layout/>
      //       </Suspense>
      //     </Aux>
      // </div>
      <React.Fragment>
          <Suspense fallback={<div style={{backgroundColor:'white'}}/>}> 
            <Layout/>
          </Suspense>
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js